/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';

import v from './validators';
import fetch from '../../core/fetch/fetch.server';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const InfoTypeDict = {
  roadNumber: {
    label: 'Numer drogi:',
    editable: true,
  },
  kindOfWork: {
    label: 'Rodzaj robót (cel zajęcia pasa drogowego):',
    editable: true,
  },
  workerInfo: {
    label: 'Generalnym wykonawcą robót będzie (nazwa, adres, nr telefonu):',
    editable: true,
  },
};

const Element1Dict = {
  elem1Length: {
    label: 'Długość [m]:',
    editable: true,
  },
  elem1Width: {
    label: 'Szerokość [m]:',
    editable: true,
  },
  elem1Area: {
    label: 'Powierzchnia [m2]:',
    editable: true,
  },
  elem1SurfaceType: {
    label: 'Rodzaj nawierzchni:',
    editable: true,
  },
};

const Element2Dict = {
  elem2Length: {
    label: 'Długość [m]:',
    editable: true,
  },
  elem2Width: {
    label: 'Szerokość [m]:',
    editable: true,
  },
  elem2Area: {
    label: 'Powierzchnia [m2]:',
    editable: true,
  },
  elem2SurfaceType: {
    label: 'Rodzaj nawierzchni:',
    editable: true,
  },
};

const Element3Dict = {
  elem3Length: {
    label: 'Długość [m]:',
    editable: true,
  },
  elem3Width: {
    label: 'Szerokość [m]:',
    editable: true,
  },
  elem3Area: {
    label: 'Powierzchnia [m2]:',
    editable: true,
  },
  elem3SurfaceType: {
    label: 'Rodzaj nawierzchni:',
    editable: true,
  },
};

const Element4Dict = {
  elem4Length: {
    label: 'Długość [m]:',
    editable: true,
  },
  elem4Width: {
    label: 'Szerokość [m]:',
    editable: true,
  },
  elem4Area: {
    label: 'Powierzchnia [m2]:',
    editable: true,
  },
  elem4SurfaceType: {
    label: 'Rodzaj nawierzchni:',
    editable: true,
  },
};

const DeviceDescDict = {
  deviceDesc: {
    label: 'Wpisz opis:',
    editable: true,
  },
};

const TakingInfoDict = {
  takingDateStart: {
    label: 'Od:',
    editable: true,
  },
  takingDateEnd: {
    label: 'Do:',
    editable: true,
  },
};

const DeviceInfoDict = {
  deviceDateStart: {
    label: 'Od:',
    editable: true,
  },
  deviceDateEnd: {
    label: 'Do:',
    editable: true,
  },
};


class ZajeciePasaDrogowego extends React.Component {
  state = {
    info: {
      roadNumber: null,
      kindOfWork: null,
      workerInfo: null,
      elem1Length: null,
      elem1Width: null,
      elem1Area: null,
      elem1SurfaceType: null,
      elem2Length: null,
      elem2Width: null,
      elem2Area: null,
      elem2SurfaceType: null,
      elem3Length: null,
      elem3Width: null,
      elem3Area: null,
      elem3SurfaceType: null,
      elem4Length: null,
      elem4Width: null,
      elem4Area: null,
      elem4SurfaceType: null,
      deviceDesc: null,
      takingDateStart: null,
      takingDateEnd: null,
      deviceDateStart: null,
      deviceDateEnd: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
    isMounted: false,
  };

  validators = {
    roadNumber: [v.NotNull],
    kindOfWork: [v.NotNull],
    workerInfo: [v.NotNull],
    elem1Length: [v.isNumber, v.NotNull],
    elem1Width: [v.isNumber, v.NotNull],
    elem1Area: [v.isNumber, v.NotNull],
    elem2Length: [v.isNumber, v.NotNull],
    elem2Width: [v.isNumber, v.NotNull],
    elem2Area: [v.isNumber, v.NotNull],
    elem3Length: [v.isNumber, v.NotNull],
    elem3Width: [v.isNumber, v.NotNull],
    elem3Area: [v.isNumber, v.NotNull],
    elem4Length: [v.isNumber, v.NotNull],
    elem4Width: [v.isNumber, v.NotNull],
    elem4Area: [v.isNumber, v.NotNull],
    deviceDesc: [v.NotNull],
    takingDateStart: [v.NotNull, v.CheckDate],
    takingDateEnd: [v.NotNull, v.CheckDate],
    deviceDateStart: [v.NotNull, v.CheckDate],
    deviceDateEnd: [v.NotNull, v.CheckDate],
    elem1SurfaceType: [v.NotNull],
    elem2SurfaceType: [v.NotNull],
    elem3SurfaceType: [v.NotNull],
    elem4SurfaceType: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });

    this.setState({ isMounted: true });
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        roadNumber: 'Nr Test',
        kindOfWork: 'Prace testowe',
        workerInfo: 'Wykonawca testowy',
        elem1Length: 10,
        elem1Width: 10,
        elem1Area: 10,
        elem1SurfaceType: 'test',
        elem2Length: 20,
        elem2Width: 20,
        elem2Area: 20,
        elem2SurfaceType: 'test2',
        elem3Length: 30,
        elem3Width: 30,
        elem3Area: 30,
        elem3SurfaceType: 'test3',
        elem4Length: 40,
        elem4Width: 40,
        elem4Area: 40,
        elem4SurfaceType: 'test4',
        deviceDesc: 'test',
        takingDateStart: '01-02-2020',
        takingDateEnd: '01-10-2020',
        deviceDateStart: '10-01-2020',
        deviceDateEnd: '01-09-2020' },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        <DecisionContainer
          title={'2. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InfoTypeDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <GrayPanel
          title={'3. Wymiary, powierzchnia oraz rodzaj zajętych elementów pasa drogowego na czas wykonywania robót:'}
        >
          <DecisionContainer
            title={'Jezdnia o nawierzchni bitumicznej:'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={Element1Dict}
            onChange={e => this.onChange(e, 'info')}
          />
          <DecisionContainer
            title={'Jezdnia o nawierzchni gruntowej:'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={Element2Dict}
            onChange={e => this.onChange(e, 'info')}
          />
          <DecisionContainer
            title={'Chodnik, pobocze, plac, zatoka, ciąg pieszy, parking:'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={Element3Dict}
            onChange={e => this.onChange(e, 'info')}
          />
          <DecisionContainer
            title={'Inne elementy:'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={Element4Dict}
            onChange={e => this.onChange(e, 'info')}
          />
        </GrayPanel>
        <DecisionContainer
          title={'4. Rodzaj, wymiary, powierzchnia urządzeń nie związanych z funkcjonowaniem drogi, lokalizowanych w wyniku prowadzenia robót:'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={DeviceDescDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <DecisionContainer
          title={'5. Okres zajęcia pasa drogowego na czas robót:'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={TakingInfoDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <DecisionContainer
          title={'6. Okres umieszczenia urządzeń niezwiązanych z funkcjonowaniem drogi w pasie drogowym:'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={DeviceInfoDict}
          onChange={e => this.onChange(e, 'info')}
        />
        <GrayPanel
          title={'7. Informacje dla wnioskodawcy'}
        >
          <b>UWAGA:</b>
          <ul>
            <li>Za zajęcie pasa drogowego pobiera się opłaty – na podstawie art. 40 ustawy z dnia 21 marca 1985 roku o drogach publicznych (t.j. Dz. U. z 2017 r. poz. 2222 ze zm.). Stawki opłat określa Uchwała Rady Gminy Domaniów Nr XXXV/234/17 z dnia 15 listopada 2017 r. w sprawie stawek opłat za zajęcie pasa drogowego dróg gminnych (Dz. Urz. Woj. Doln. z 2017 r. poz. 4855) zmieniona Uchwałą Rady Gminy Domaniów Nr XXXVII/247/17 z dnia 28 grudnia 2017 r. zmieniająca uchwałę w sprawie stawek opłat za zajęcie pasa drogowego dróg gminnych (Dz. Urz. Woj. Doln. z 2018 r. poz. 132)</li>
            <li>Jeżeli roboty będą prowadzone bez wymaganej opłaconej decyzji, zarządca drogi zgodnie z art. 40 ust. 12 ustawy z dnia 21 marca 1985r. o drogach publicznych naliczy Wykonawcy robót stosowną karę pieniężną z tytułu samowolne zajęcia pasa drogowego.</li>
          </ul>
          <b>Do wniosku dołącza się:</b>
          <ul>
            <li>Szczegółowy plan sytuacyjny w skali 1:1.000 lub 1:500, z zaznaczeniem granic i podaniem wymiarów planowanej powierzchni zajęcia pasa drogowego, a w przypadku umieszczenia reklamy – z podaniem jej wymiarów</li>
            <li>oryginał pełnomocnictwa</li>
            <li>opłata skarbowa – 17 zł</li>
            <li>przekrój poprzeczny zajętego pasa drogowego z naniesionymi urządzeniami umieszczonymi w pasie drogowym (jeśli takie urządzenia będą umieszczane),</li>
            <li>zatwierdzony projekt organizacji ruchu, jeżeli zajęcie pasa drogowego wpływa na ruch drogowy lub ogranicza widoczność na drodze albo powoduje wprowadzenie zmian w istniejącej organizacji ruchu pojazdów lub pieszych (projekt organizacji ruchu związany z robotami prowadzonymi w pasie drogowym powinien określać sposób zabezpieczenia tych robót zgodnie z wymogami bezpieczeństwa ruchu drogowego)</li>
            <li>ogólny plan orientacyjny w skali 1:10.000 lub 1:25.000 z zaznaczeniem zajmowanego odcinka pasa drogowego oraz informację o sposobie zabezpieczenia robót, jeżeli nie jest wymagany projekt organizacji ruchu</li>
            <li>oświadczenie o:
                <ul>
                  <li>posiadaniu ważnego pozwolenia na budowę obiektu umieszczonego w pasie drogowym lub</li>
                  <li>zgłoszeniu budowy lub prowadzonych robót właściwemu organowi administracji architektoniczno-budowlanej, lub</li>
                  <li>zamiarze budowy przyłączy elektroenergetycznych, wodociągowych, kanalizacyjnych, gazowych cieplnych i telekomunikacyjnych, dla których sporządzono plan sytuacyjny na kopii aktualnej mapy zasadniczej lub mapy jednostkowej przyjętej do państwowego zasobu geodezyjnego i kartograficznego</li>
                </ul>
            </li>
            <li>W przypadku zajęcia pasa drogowego w celu prowadzenia robót do wniosku, zarządca drogi może zażądać dostarczenia dodatkowych dokumentów, a w szczególności:
                <ul>
                  <li>Projektu budowlanego obiektu umieszczonego w pasie drogowym;</li>
                  <li>Harmonogramu robót prowadzonych w pasie drogowym, zwłaszcza w przypadkach etapowego prowadzenia robót.</li>
                </ul>
            </li>
          </ul>
        </GrayPanel>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ZajeciePasaDrogowego.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(ZajeciePasaDrogowego),
);



// WEBPACK FOOTER //
// src/routes/eservices/ZajeciePasaDrogowego.js